<script lang="ts">
    import { useComparisonContext } from '@shared/providers/comparison-context/ComparisonContext.browser.ts';
    import type { Variation } from '@shared/types/types.ts';

    interface Props {
        currentVariation: Variation;
    }
    let { currentVariation }: Props = $props();
    const context = useComparisonContext();

    const currentVariationIsSelected = $derived(
        context.selectedVariations.some((v) => v.variationId === currentVariation.variationId),
    );

    const showCompareCheckbox = $derived(context.showComparison && currentVariation.pbk === context.comparisonId);

    export const handleCheckboxInteraction = () => {
        if (currentVariationIsSelected) {
            context.deselectVariation(currentVariation.variationId);
        } else {
            context.selectVariation(currentVariation);
        }
    };
</script>

{#if showCompareCheckbox}
    <div class="reptile_tile__productComparisonCheckbox">
        <!-- svelte-ignore a11y_no_static_element_interactions -->
        <!-- svelte-ignore a11y_click_events_have_key_events -->
        <oc-checkbox-v1
            checked={currentVariationIsSelected}
            onclick={handleCheckboxInteraction}
            label-placement="left"
            fit-content
            data-qa="reptile-product-comparison-checkbox"
        >
            <p class="reptile_tile__productComparisonLabel">Produkt vergleichen</p>
        </oc-checkbox-v1>
    </div>
{/if}

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens' as tokens;
    @use '@otto-ec/otto-components-utils/scss/mixins' as mixins;
    .reptile_tile__productComparisonCheckbox {
        margin-top: tokens.$oc-base-dimension-12;
        margin-left: tokens.$oc-base-dimension-16;
        margin-right: tokens.$oc-base-dimension-16;
        display: flex;
        justify-content: flex-end;

        @include mixins.breakpoint-from-l() {
            margin-top: tokens.$oc-base-dimension-16;
            margin-left: tokens.$oc-base-dimension-0;
        }

        .reptile_tile__productComparisonLabel {
            display: inline-block;
            text-align: right;
            order: 1;
            margin-left: tokens.$oc-base-dimension-0;
            margin-bottom: tokens.$oc-base-dimension-16;
            cursor: pointer;
            font-size: tokens.$oc-base-font-line-height-75;
            line-height: tokens.$oc-base-font-line-height-100;
            margin-right: tokens.$oc-base-dimension-0;
            max-width: 100%;
        }
    }
</style>
